/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desc_Nfp_VerificationInputs */

const en_desc_nfp_verification = /** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload your charity registration document. Our team reviews within 2 business days.`)
};

const es_desc_nfp_verification = /** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube el documento de registro de tu organización benéfica. Nuestro equipo lo revisa en 2 días hábiles.`)
};

const fr_desc_nfp_verification = /** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez votre document d'enregistrement d'association. Notre équipe l'examine dans les 2 jours ouvrables.`)
};

const de_desc_nfp_verification = /** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade das Registrierungsdokument deiner Wohltätigkeitsorganisation hoch. Unser Team prüft es innerhalb von 2 Werktagen.`)
};

const id_desc_nfp_verification = /** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah dokumen pendaftaran yayasan/amal Anda. Tim kami meninjaunya dalam 2 hari kerja.`)
};

/** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */
const ja_desc_nfp_verification = en_desc_nfp_verification;

/** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */
const zh_desc_nfp_verification = en_desc_nfp_verification;

/** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */
const ar_desc_nfp_verification = en_desc_nfp_verification;

/** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */
const it_desc_nfp_verification = en_desc_nfp_verification;

/** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */
const ru_desc_nfp_verification = en_desc_nfp_verification;

/** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */
const pt_desc_nfp_verification = en_desc_nfp_verification;

/** @type {(inputs: Desc_Nfp_VerificationInputs) => LocalizedString} */
const ko_desc_nfp_verification = en_desc_nfp_verification;

/**
* | output |
* | --- |
* | "Upload your charity registration document. Our team reviews within 2 business days." |
*
* @param {Desc_Nfp_VerificationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const desc_nfp_verification = /** @type {((inputs?: Desc_Nfp_VerificationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desc_Nfp_VerificationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_desc_nfp_verification(inputs)
	if (locale === "es") return es_desc_nfp_verification(inputs)
	if (locale === "fr") return fr_desc_nfp_verification(inputs)
	if (locale === "de") return de_desc_nfp_verification(inputs)
	if (locale === "ja") return ja_desc_nfp_verification(inputs)
	if (locale === "zh") return zh_desc_nfp_verification(inputs)
	if (locale === "ar") return ar_desc_nfp_verification(inputs)
	if (locale === "id") return id_desc_nfp_verification(inputs)
	if (locale === "it") return it_desc_nfp_verification(inputs)
	if (locale === "ru") return ru_desc_nfp_verification(inputs)
	if (locale === "pt") return pt_desc_nfp_verification(inputs)
	return ko_desc_nfp_verification(inputs)
});